/**
 * The brand's SOPs, running workflows and knowledge sources as options to pick a source from, each with
 * the name it is shown by.
 */

import { useMemo } from 'react';
import { useAllSOPs, useRunningWorkflows, useSources } from '@/hooks';
import { sopHeading } from '../../format';
import type { SourceOption } from './source-kinds';

export const useSourceOptions = (): SourceOption[] => {
	const { data: sops = [] } = useAllSOPs();
	const { data: workflows = [] } = useRunningWorkflows();
	// Knowledge a run reports is a source's id: Brahma's search reads it off the indexed chunk.
	const { data: knowledgeSources = [] } = useSources();
	return useMemo<SourceOption[]>(
		() => [
			...sops.map((sop) => ({ kind: 'sopIds' as const, id: sop.id, name: sopHeading(sop.intent) })),
			...workflows.map((workflow) => ({ kind: 'workflowIds' as const, id: workflow.id, name: workflow.name })),
			...knowledgeSources.map((source) => ({ kind: 'knowledgeIds' as const, id: source.id, name: source.name }))
		],
		[sops, workflows, knowledgeSources]
	);
};
